
export enum SwipeActionEnum {
    None = 0,
    Left = 1,
    Right = 2,
    PullToRefresh = 3
};

export type LayoutContextType = {
    scrollTarget: HTMLDivElement | undefined;
    swipeAction: SwipeActionEnum | undefined;
    viewAll: boolean;
};

export enum LayoutContextActionType {
    ScrollTargetSet = 'scrollTargetSet',
    SwipeChanged = 'LAYOUT_SWIPE_CHANGED',
    ViewAllChanged = 'LAYOUT_VIEW_ALL_CHANGED'
}

export type LayoutActions = {
    type: LayoutContextActionType.ScrollTargetSet;
    scrollTarget: HTMLDivElement | undefined;
} | {
    type: LayoutContextActionType.SwipeChanged;
    payload: SwipeActionEnum | undefined;
} | {
    type: LayoutContextActionType.ViewAllChanged;
    payload: boolean;
};
